import { partners } from "../constants/actionTypes";

const initialState = {
  loading: false,
  stats: {
    clicks: 0,
    signups: 0,
    customers: 0,
    total_earnings: 0,
    pending_earnings: 0
  },
  status: {
    partnero_id: null,
    partnero_status: null,
    referral_link: null,
    partner_enrolled_at: null
  },
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case partners.SET_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    case partners.SET_STATS:
      return {
        ...state,
        stats: {
          ...state.stats,
          ...action.payload
        }
      };

    case partners.SET_STATUS:
      return {
        ...state,
        status: action.payload
      };

    case partners.SET_ERROR:
      return {
        ...state,
        error: action.payload
      };

    case partners.CLEAR_ERROR:
      return {
        ...state,
        error: null
      };

    default:
      return state;
  }
};
